(function() {
  'use strict';

  const MOBILE_BREAKPOINT = 750;

  function initHeroParallax() {
    const hero = document.querySelector('.hero-parallax--layered[data-parallax="true"]');
    if (!hero) return;

    const layers = hero.querySelectorAll('[data-parallax-layer]');
    if (layers.length === 0) return;

    // Check for reduced motion preference
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    // Movement intensity per layer (pixels)
    const intensityDesktop = { 1: 8, 2: 20, 3: 0 };
    const intensityMobile = { 1: 5, 2: 9, 3: 0 };  // Layers 1 & 2 move on mobile

    let isMobile = window.innerWidth < MOBILE_BREAKPOINT;
    let animationId = null;
    let isVisible = false;
    let isRunning = false;
    let mouseX = 0.5;
    let mouseY = 0.5;
    let currentX = 0.5;
    let currentY = 0.5;
    let driftAngle = 0;

    // Smooth interpolation factor (lower = smoother/slower)
    const smoothing = 0.08;

    function updateLayers() {
      layers.forEach(layer => {
        const layerNum = parseInt(layer.dataset.parallaxLayer, 10);
        const intensity = isMobile ? intensityMobile : intensityDesktop;
        const maxMove = intensity[layerNum] ?? 0;

        let offsetX, offsetY;

        if (isMobile) {
          // Mobile: subtle but visible circular drift
          offsetX = Math.sin(driftAngle) * maxMove * 0.7;
          offsetY = Math.cos(driftAngle * 0.7) * maxMove * 0.5;
        } else {
          // Desktop: follow mouse with easing
          offsetX = (currentX - 0.5) * 2 * maxMove;
          offsetY = (currentY - 0.5) * 2 * maxMove;
        }

        layer.style.transform = `translate3d(${offsetX}px, ${offsetY}px, 0)`;
      });
    }

    function animate() {
      if (!isVisible) {
        isRunning = false;
        return;
      }

      if (isMobile) {
        driftAngle += 0.010;
      } else {
        currentX += (mouseX - currentX) * smoothing;
        currentY += (mouseY - currentY) * smoothing;
      }

      updateLayers();
      animationId = requestAnimationFrame(animate);
    }

    function startAnimation() {
      if (isRunning) return;
      isRunning = true;
      animate();
    }

    function stopAnimation() {
      if (animationId) {
        cancelAnimationFrame(animationId);
        animationId = null;
      }
      isRunning = false;
    }

    function onMouseMove(e) {
      if (isMobile) return;

      const rect = hero.getBoundingClientRect();
      mouseX = (e.clientX - rect.left) / rect.width;
      mouseY = (e.clientY - rect.top) / rect.height;

      // Clamp values
      mouseX = Math.max(0, Math.min(1, mouseX));
      mouseY = Math.max(0, Math.min(1, mouseY));
    }

    function onMouseLeave() {
      if (isMobile) return;
      mouseX = 0.5;
      mouseY = 0.5;
    }

    // Debounced resize handler
    let resizeTimeout;
    function onResize() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        const wasMobile = isMobile;
        isMobile = window.innerWidth < MOBILE_BREAKPOINT;

        if (wasMobile !== isMobile) {
          currentX = 0.5;
          currentY = 0.5;
          mouseX = 0.5;
          mouseY = 0.5;
          driftAngle = 0;
        }
      }, 100);
    }

    // IntersectionObserver to pause when off-screen
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        isVisible = entry.isIntersecting;
        if (isVisible) {
          startAnimation();
        } else {
          stopAnimation();
        }
      });
    }, { threshold: 0 });

    observer.observe(hero);

    // Event listeners
    hero.addEventListener('mousemove', onMouseMove, { passive: true });
    hero.addEventListener('mouseleave', onMouseLeave);
    window.addEventListener('resize', onResize, { passive: true });

    // Cleanup on page unload
    window.addEventListener('beforeunload', function() {
      stopAnimation();
      observer.disconnect();
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroParallax);
  } else {
    initHeroParallax();
  }
})();
